export default {
  "grapesjs-signature-pad": {
    name: "Unterschriftsfeld",
    "call-to-action": "Bitte hier unterschreiben",
  },
};
